import { makeStyles } from '@material-ui/core/styles';
import getBrand from '../../../utils/getBrand';

const isCelebrity = getBrand()?.id === 'cel';

const useStyles = makeStyles((Theme) => ({
  baseButton: {
    textTransform: 'initial',
    fontSize: Theme.typography.size[1],
    width: '100%',
    padding: '8px 20px',
    borderRadius: `${isCelebrity ? '1px' : '4px'}`,
    fontFamily: Theme.typography.base.semiBold,
    // minHeight, not height: a fixed height cannot contain a label that wraps, and the overflow
    // is centred, so the text spills out above AND below the border rather than being clipped at
    // one edge. The cancellation modal showed "No," floating over the top border and "back" under
    // the bottom one. Buttons that fit on one line are unaffected — 40px is still their height.
    minHeight: 40,

    '&.MuiButton-containedPrimary': {
      backgroundColor: `${isCelebrity ? Theme.palette.primary.main : Theme.palette.primary.light}`,
    },

    '&.Mui-disabled': {
      backgroundColor: `${Theme.palette.gray[500]}`,
      color: Theme.palette.white,
    },

    [Theme.breakpoints.up('sm')]: {
      width: 'auto',
      padding: '12px 32px',
    },
    [Theme.breakpoints.up('lg')]: {
      fontSize: Theme.typography.size[3],
      minHeight: 56,
    },

    '&.MuiButton-outlined': {
      border: `1px solid ${Theme.palette.secondary.main}`,
      color: Theme.palette.secondary.main,
    },
  },
}));

export default useStyles;
